
































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class IntegrationsShell extends Vue {
  @Prop() name!: string;
  @Prop() prettyName!: string;
  @Prop() integrators!: Array<{
    prettyName: string;
    code: string;
    image: string;
    fields: Array<{ type: 'text' | 'number'; name: string }>;
  }>;
}
